import React from 'react';
import { Modal, Button } from 'react-bootstrap';

// Props:
// show: boolean - whether modal is visible
// onClose: function - close callback
// survey: object - survey metadata
// questions: array - list of questions
function SurveyPreviewModal({ show, onClose, survey, questions }) {
    return (
        <Modal show={show} onHide={onClose} size="lg" centered scrollable>
            <Modal.Header closeButton>
                <Modal.Title>{survey?.title || 'Survey Preview'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {survey?.description && (
                    <p className="text-muted mb-4">{survey.description}</p>
                )}

                {questions?.length > 0 ? (
                    <div className="list-group">
                        {questions.map((q, index) => (
                            <div
                                key={q.id || index}
                                className="list-group-item list-group-item-action mb-2 shadow-sm"
                            >
                                <div className="d-flex justify-content-between align-items-start">
                                    <div>
                                        <strong>{index + 1}. {q.title || 'Untitled Question'}</strong>
                                        <p className="mb-1 text-muted">{q.description || ''}</p>
                                    </div>
                                    <span className="badge bg-primary rounded-pill">{q.type}</span>
                                </div>

                                {/* Display options if question has them */}
                                {q.options?.length > 0 && (
                                    <ul className="mt-2 mb-0">
                                        {q.options.map(opt => (
                                            <li key={opt.id || opt.value}>{opt.text}</li>
                                        ))}
                                    </ul>
                                )}

                                {/* For rating questions, show range */}
                                {q.type === 'rating' && (
                                    <p className="mt-2 text-muted">
                                        Rating: {q.minValue ?? 1} to {q.maxValue ?? 5} ({q.ratingType ?? 'stars'})
                                    </p>
                                )}
                            </div>
                        ))}
                    </div>
                ) : (
                    <p className="text-muted">No questions available to preview.</p>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onClose}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default SurveyPreviewModal;
